export default "__VITE_ASSET__Dw7lP5eb__"